var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlobLogoSenasteNytt = function SvgBlobLogoSenasteNytt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 67"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 142,
    height: 66,
    x: 60,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4DA7B9",
    fillRule: "evenodd",
    d: "M115.695 61.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 29.9 73.349 1.593 100.877 1.593c27.528 0 29.235 2.1 62.568.991s50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C89",
    fillRule: "evenodd",
    d: "M115.695 61.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 29.9 73.349 1.593 100.877 1.593c27.528 0 29.235 2.1 62.568.991s50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F88F78",
    d: "M201.5 62c-.604-5.669 11.454-32.47 5-38-75-12.5-120-6-149 1.5C42.144 52.686 84 68 104 70.5c32 0 67.5 6.5 97.5-8.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDD9B",
    fillRule: "evenodd",
    d: "M72.475 37.366c-.57 16.311-19.4 30.297-35.662 29.73C20.552 66.529.261 58.304.832 41.994 1.402 25.665 25.058 5.165 41.32 5.732c16.668.582 31.724 15.323 31.154 31.634Z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    }
  }));
};
export default SvgBlobLogoSenasteNytt;